<div class="main-content table-page cc-pagina cc-reportes">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Reportes</h1>
        <p>Cada folio guarda la foto de SonarQube con que se armó y se vuelve a bajar idéntico, aunque el análisis ya se haya purgado.</p>
      </div>
      <div class="table-page__toolbar-actions cc-reportes__acciones">
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" [routerLink]="rutaTablero">
          <span class="material-icons" aria-hidden="true">dashboard</span>
          Tablero
        </a>
        <button mat-raised-button type="button" class="btn table-page__primary-btn" *ngIf="puedeReportar" (click)="nuevoQa()">
          <span class="material-icons" aria-hidden="true">summarize</span>
          Nuevo reporte para QA
        </button>
      </div>
    </section>

    <!-- Lo que deja la última acción (folio bajado, reporte para QA emitido) va como flotante arriba a la derecha (flotantes/). -->

    <section class="table-page__card">
      <div class="table-page__empty cc-reportes__vacio" *ngIf="estado === 'CARGANDO'">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando los reportes</h3>
        <p>Espere un momento.</p>
      </div>

      <div class="table-page__empty cc-reportes__vacio" *ngIf="estado === 'ERROR'">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudieron consultar los reportes</h3>
        <p>{{ error }}</p>
        <div class="cc-vacio__acciones">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="consultar()">
            Volver a consultar
          </button>
        </div>
      </div>

      <div class="table-page__empty cc-reportes__vacio" *ngIf="estado === 'VACIO'">
        <span class="material-icons" aria-hidden="true">summarize</span>
        <h3>Todavía no se ha emitido ningún reporte</h3>
        <p>El PDF de un proyecto se emite desde el tablero o su detalle; el consolidado para QA, con el botón de arriba.</p>
      </div>

      <div class="table-page__table-wrap" [class.cc-atenuado]="consultando" *ngIf="estado === 'DATOS'">
        <table class="table-page__table cc-reportes__tabla" #tabla [style.--cc-fila-extra]="extraFila + 'px'">
          <caption class="cc-oculto">Reportes emitidos, del más reciente al más viejo.</caption>
          <thead>
            <tr>
              <th scope="col">Folio</th>
              <th scope="col">Proyectos</th>
              <th scope="col">Emitido por</th>
              <th scope="col">Fecha</th>
              <th scope="col">Huella</th>
              <th scope="col" class="table-page__actions-head"><span class="cc-oculto">Acciones</span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of filas; let i = index; trackBy: trackFila" class="cc-entra" [style.animation-delay.ms]="i * 25">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name cc-mono">{{ f.folio }}</strong>
                  <span class="cc-insignia cc-reportes__tipo" [ngClass]="f.tipoClase">{{ f.tipo }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text cc-reportes__proyectos" [attr.title]="f.proyectosCompletos">{{ f.proyectos }}</span>
                  <span class="table-page__subtext cc-sec" *ngIf="f.analisis">{{ f.analisis }}</span>
                </div>
              </td>
              <td>{{ f.emitidoPor }}</td>
              <td class="cc-num cc-reportes__fecha">{{ f.fecha }}</td>
              <td><span class="cc-mono cc-num" [attr.title]="f.huellaCompleta">{{ f.huella }}</span></td>
              <td class="table-page__actions cc-reportes__acciones-fila">
                <button type="button" class="cc-boton-icono" title="Bajar el PDF" [disabled]="bajando !== null" (click)="pdf(f)">
                  <span class="material-icons" aria-hidden="true">{{ estaBajando(f, "PDF") ? "hourglass_top" : "picture_as_pdf" }}</span>
                  <span class="cc-oculto">{{ f.etiquetaPdf }}</span>
                </button>
                <button type="button" class="cc-boton-icono" title="Bajar el Excel" [disabled]="bajando !== null" (click)="excel(f)">
                  <span class="material-icons" aria-hidden="true">{{ estaBajando(f, "EXCEL") ? "hourglass_top" : "grid_on" }}</span>
                  <span class="cc-oculto">{{ f.etiquetaExcel }}</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-page__footer" *ngIf="estado === 'DATOS'">
        <div class="table-page__meta cc-sec"><span>{{ textoRango }}</span></div>
        <div class="table-page__pager" *ngIf="paginas.length > 1">
          <button type="button" class="table-page__pager-link" [disabled]="pagina === 1 || consultando" (click)="irA(pagina - 1)">Anterior</button>
          <button type="button" class="table-page__pager-page" *ngFor="let n of paginas" [class.is-current]="n === pagina"
                  [attr.aria-current]="n === pagina ? 'page' : null" [disabled]="consultando" (click)="irA(n)">{{ n }}</button>
          <button type="button" class="table-page__pager-link" [disabled]="pagina === paginas.length || consultando" (click)="irA(pagina + 1)">Siguiente</button>
        </div>
      </div>
    </section>
  </div>
</div>
